module.exports = __webpack_public_path__ + "img/67f70b854355de7cc5b8e803edff88e0.1b52d0bc.webp";